import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'aot_cookie_consent';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    // data-bottom-overlay: floating UI (the support button) measures these and
    // sits above them. On a phone this banner is three lines tall and used to
    // bury the button until it was dismissed.
    <div
      data-bottom-overlay
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-700 bg-slate-900/95 px-4 py-3 backdrop-blur-sm sm:px-6"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 sm:flex-row sm:justify-between">
        <p className="text-center text-sm text-slate-300 sm:text-left">
          Art of Thinking sets no cookies. Your browser's own storage keeps you signed in, and our analytics uses no cookies.{' '}
          <Link to="/privacy-policy" className="text-emerald-400 underline hover:text-emerald-300">
            Privacy Policy
          </Link>
        </p>
        <button
          onClick={handleAccept}
          className="shrink-0 rounded-md bg-emerald-600 px-4 py-1.5 text-sm font-medium text-white transition hover:bg-emerald-500"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
